import { Pipe, PipeTransform } from '@angular/core';
import { DateFilter, Filter, FilterTypes } from '@models/filter-types';

@Pipe({
    name: 'isDateFilter',
    standalone: false,
})
export class IsDateFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is DateFilter {
        return value?.Type === FilterTypes.DateFilterType;
    }
}
